import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import BreadcrumbComponent from '@/components/breadcrumb';
import { useMainContext } from '@/context/main-context';

import DeleteAlert from '@/components/dialogs/delete-alert';
import EditDialog from '@/components/dialogs/edit-dialog';
import GroupCard from '@/components/groups/card';
import GroupEdit from '@/components/groups/edit';
import FilterGroups from '@/components/groups/filter';

function Groups({ fromMain = false }) {
  const { groups, teachers, teacherId } = useMainContext();
  const [openGroupEditDialog, setOpenGroupEditDialog] = useState(false);
  const [openGroupDeleteDialog, setOpenGroupDeleteDialog] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredGroups, setFilteredGroups] = useState(groups);
  const [dayFilter, setDayFilter] = useState('all');

  useEffect(() => {
    const handler = setTimeout(() => {
      const newFilteredGroups = groups.filter((group) => {
        const groupName = group.groupName || '';
        const teacherName =
          teachers.find((item) => item.id === group.teacherId)?.fullName || '';

        const matchesSearch =
          groupName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          teacherName.toLowerCase().includes(searchTerm.toLowerCase());

        let matchesDay = true;
        if (dayFilter !== 'all') {
          matchesDay = group.dayType === dayFilter;
        }

        return matchesSearch && matchesDay;
      });

      setFilteredGroups(newFilteredGroups);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm, groups, teachers, dayFilter]);

  return (
    <div
      className={`mx-auto my-4 space-y-4 ${fromMain ? 'px-0' : 'px-4 lg:px-7'}`}
    >
      {!fromMain && <BreadcrumbComponent title="Guruhlar ro'yxati" />}

      <EditDialog open={openGroupEditDialog} setOpen={setOpenGroupEditDialog}>
        <GroupEdit />
      </EditDialog>

      <DeleteAlert
        open={openGroupDeleteDialog}
        setOpen={setOpenGroupDeleteDialog}
      />

      {!fromMain && (
        <div>
          <h2 className="text-2xl font-bold tracking-tight">
            Mening Guruhlarim
          </h2>
          <p className="text-muted-foreground">
            Menga biriktiligan barcha guruhlar ro'yxati!
          </p>
        </div>
      )}

      <FilterGroups
        groupPage={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        dayFilter={dayFilter}
        setDayFilter={setDayFilter}
      />

      <div className="overflow-x-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 min-w-0">
          {filteredGroups.map((card) => (
            <Link
              key={card.id}
              to={card.teacherId === teacherId ? `/groups/${card.id}` : null}
            >
              <GroupCard card={card} />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Groups;
